import { render, staticRenderFns } from "./AdditionalEditor.vue?vue&type=template&id=d80ad336"
import script from "./AdditionalEditor.vue?vue&type=script&lang=js"
export * from "./AdditionalEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports